
import axiosInstance from "./AxiosInstanceMain";

export const getFormsByPageApi = async (pageId) => {
  const res = await axiosInstance.get(`/admin/fb-leadgen/forms-by-page?pageId=${pageId}`);
  return res.data;
};

export const getLeadsApi = async (params) => {
  const res = await axiosInstance.get(`/admin/fb-leadgen/leads`, { params });
  return res.data;
};
